export default {
  closeMiniappBtn: 'close-miniapp-button',
  cancelBtn: 'cancel-button',
  applyBtn: 'apply-button',
};
